module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/~/core-js/library/modules/_redefine.js
// module id = 271
// module chunks = 92